// extracted by mini-css-extract-plugin
module.exports = {"exitSymbol":"Menu_exitSymbol__3gJod"};